import React from 'react';
import styles from './AdminTable.module.scss';
import { UserRoleEnum } from '@src/types';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { 
  IconUser, 
  IconUserManage, 
  IconDistAdmin 
} from '@constants';

type RoleIconProps = {
  role: string;
};

/**
 * RoleIcon - A component to display a role icon using Lord Icons
 * 
 * This component takes a role and displays the corresponding Lord Icon.
 * It uses the role to determine which icon to display.
 */
const RoleIcon: React.FC<RoleIconProps> = ({ role }) => {
  let iconSrc = IconUser;
  let colors = { primary: '#274649', secondary: '#FFB073' };
  let title = role;

  switch (role) {
    case UserRoleEnum.User:
      iconSrc = IconUser;
      break;
    case UserRoleEnum.Admin:
      iconSrc = IconUserManage;
      colors = { primary: '#274649', secondary: '#FFB073' };
      break;
    case UserRoleEnum.SuperAdmin:
      iconSrc = IconUserManage;
      colors = { primary: '#FF5757', secondary: '#FFB073' };
      break;
    case UserRoleEnum.DistrictAdmin:
      iconSrc = IconDistAdmin;
      colors = { primary: '#274649', secondary: '#FFB073' };
      break;
    case UserRoleEnum.ContentAdmin:
      iconSrc = IconUserManage;
      colors = { primary: '#274649', secondary: '#FFB073' };
      break;
    default:
      iconSrc = IconUser;
      title = 'Unknown Role';
  }

  // Get the full role name for the tooltip
  const fullRoleName = role === UserRoleEnum.SuperAdmin ? 'OP Super Admin' :
                      role === UserRoleEnum.ContentAdmin ? 'OP Content Admin' :
                      role === UserRoleEnum.Admin ? 'School Admin' :
                      role === UserRoleEnum.DistrictAdmin ? 'District Admin' :
                      role === UserRoleEnum.User ? 'User' : role;

  return (
    <div 
      title={fullRoleName} 
      className={styles.roleIconContainer}
      style={{ cursor: 'default' }}
    >
      <LordIcon 
        src={iconSrc} 
        colors={colors} 
        size={24} 
        trigger="hover"
      />
      <span className={styles.roleText}>
        {role === UserRoleEnum.SuperAdmin ? 'OPSA' :
         role === UserRoleEnum.ContentAdmin ? 'OPCA' :
         role === UserRoleEnum.Admin ? 'SA' :
         role === UserRoleEnum.DistrictAdmin ? 'DA' :
         role === UserRoleEnum.User ? 'User' : role}
      </span>
    </div>
  );
};

export default RoleIcon;
